import orderBy from 'lodash/orderBy'
import { GeckoEntry } from 'types'

import { AsPipelineStatus } from './rolodexEntryTypes'

export function entriesToAsPipelineStatus(
  entry: readonly GeckoEntry[]
): AsPipelineStatus | undefined {
  if (entry.length === 0) {
    return undefined
  }

  const entryData = entry[0].data as Record<
    string,
    Omit<AsPipelineStatus, 'triggered_date'> & { triggered_date: string }
  >
  const selectedTriggerID = Object.keys(entryData).length
    ? orderBy(
        Object.keys(entryData),
        (triggerID) => new Date(entryData[triggerID]?.triggered_date),
        ['desc']
      )[0]
    : undefined

  const selectedTriggerData = selectedTriggerID
    ? entryData[selectedTriggerID]
    : undefined

  return selectedTriggerData && selectedTriggerID
    ? {
        ...selectedTriggerData,
        trigger_id: selectedTriggerID,
        triggered_date: new Date(selectedTriggerData.triggered_date),
      }
    : undefined
}
